function cov_1394r3u02h() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown12.tsx";
  var hash = "4304af483766a94dfe5b8b409d05ba1fcea6dff2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown12.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4304af483766a94dfe5b8b409d05ba1fcea6dff2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1394r3u02h = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1394r3u02h();
var Icon = (cov_1394r3u02h().s[0]++, {
  name: 'chevron-down-12',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.88388 3.61612C10.372 4.10427 10.372 4.89573 9.88388 5.38388L6.88388 8.38388C6.39573 8.87204 5.60427 8.87204 5.11612 8.38388L2.11612 5.38388C1.62796 4.89573 1.62796 4.10427 2.11612 3.61612C2.60427 3.12796 3.39573 3.12796 3.88388 3.61612L6 5.73223L8.11612 3.61612C8.60427 3.12796 9.39573 3.12796 9.88388 3.61612Z\" fill=\"currentColor\"/>"
});
export default Icon;